export var HTMLElementProperty;
(function (HTMLElementProperty) {
    HTMLElementProperty["Width"] = "width";
    HTMLElementProperty["MinWidth"] = "min-width";
    HTMLElementProperty["MaxWidth"] = "max-width";
    HTMLElementProperty["Height"] = "height";
    HTMLElementProperty["MinHeight"] = "min-height";
    HTMLElementProperty["MaxHeight"] = "max-height";
    HTMLElementProperty["MarginTop"] = "margin-top";
    HTMLElementProperty["MarginRight"] = "margin-right";
    HTMLElementProperty["MarginBottom"] = "margin-bottom";
    HTMLElementProperty["MarginLeft"] = "margin-left";
    HTMLElementProperty["Opacity"] = "opacity";
    HTMLElementProperty["PaddingTop"] = "padding-top";
    HTMLElementProperty["PaddingRight"] = "padding-right";
    HTMLElementProperty["PaddingBottom"] = "padding-bottom";
    HTMLElementProperty["PaddingLeft"] = "padding-left";
    HTMLElementProperty["Scale"] = "scale";
    HTMLElementProperty["ScrollLeft"] = "scroll-left";
    HTMLElementProperty["ScrollTop"] = "scroll-top";
    HTMLElementProperty["Top"] = "top";
    HTMLElementProperty["Bottom"] = "bottom";
    HTMLElementProperty["Left"] = "left";
    HTMLElementProperty["Right"] = "right";
    HTMLElementProperty["TranslateX"] = "translate-x";
    HTMLElementProperty["TranslateY"] = "translate-y";
    HTMLElementProperty["FullHeight"] = "full-height";
    HTMLElementProperty["FullWidth"] = "full-width";
})(HTMLElementProperty || (HTMLElementProperty = {}));
//# sourceMappingURL=HTMLElementProperty.js.map